import { Environment, EnvironmentName } from "../models/environment";
import { UserKeysTypes } from "../models/user";

const protocol = 'https://'; 
const axp_host = 'na.cc.avayacloud.com';

const api = {
  host: 'chat.avaya.com:443',
  entrypoint: 'BackendAvayaCC/api'
}

const static_obj = {
  host: "onecare.avaya.com",
  entrypoint: "static/media"
};
const defaultQueue = "aco_english";


export const prod: { [key: string]: Environment[] } = {
    "ACO": [{
        env: EnvironmentName.prod,
        bot: {
            name: 'Avaya Cloud Office Bot - ACO - Stage'
        },
        visible:true,
        protocol: protocol,
        url: {
            axp: {
                host: axp_host
            },
            api: api,
            static: static_obj,
            gTranslate: {
                host: '',
                entrypoint: ''
            },
            cloudFunction: {
                host: '',
                entrypoint: ''
            }
        },
        default_queue: defaultQueue,
        allowed_paths: ["*"],
        mandatory_properties: {
            'function': ['1397259904096'],
            // 'category': ['1399863147537']
        },
        auth: {
            local_storage_var_name: 'ringUser',
            access_token_path: 'value.accessToken',
            company_id_path: 'value.companyId',
            email_id_path: 'value.emailId',
            first_name_path: 'value.firstName',
            last_name_path: 'value.lastName',
            phone_number_path: 'value.phoneNumber',
            user_role_path: 'value.userRole',
            user_type_path: 'value.userType',
            user_id_path: 'value.userId'

        },
        envEndpoint: {
            api: {
                backend: '/backendavayacc',
                firestore: '/firestoreData',
                saveTranscript: '/eptcct-axp-getEngagement/api/saveTranscript',
                engagementLanguage: '/eptcct-axp-getEngagement/api/getEngagement'
            },
            static: {
                media: 'static/media',
            }
        }
    }],
    "GSS": [
        {
            env: EnvironmentName.prod,
            bot: {
                name: 'Avaya Cloud Office Bot - GSS - Stage'
            },
            visible:true,
            protocol: protocol,
            url: {
                axp: {
                    host: axp_host
                },
                api: {
                    host: api.host,
                    entrypoint: 'BackendAvayaCC_gss/api'
                },
                static: static_obj,
                gTranslate: {
                    host: '',
                    entrypoint: ''
                },
                cloudFunction: {
                    host: '',
                    entrypoint: ''
                }
            },
            default_queue: "gss_intl_sd",
            dynamic_queue: {
                user_value: UserKeysTypes.LOCATION,
                preprocessing: (value:string) => {
                    return value.split("_")
                },
                rules: {

                    gss_us_sd: {
                        accepted_values: ["US"],
                        default_agent_language: "en-US",
                    },
                    gss_cala_es: {
                        accepted_values: ["es"],
                        default_agent_language: "es-ES",
                    },
                    gss_cala_pt: {
                        accepted_values: ["pt"],
                        default_agent_language: "pt-BR",
                    },
                    // Default queue
                    gss_intl_sd: {
                        exclude_values: ["US"],
                        default_agent_language: "en-US",
                    },
                }
            },
            allowed_paths: ["*"],
            mandatory_properties: {
                'function': ['1397259904096'],
                // 'category': ['1399863147537']
            },
            auth: {
                local_storage_var_name: 'wc',
                access_token_path: 'user.sso_session_id',
                company_id_path: 'user.userInfo.customer_number',
                email_id_path: 'user.userInfo.E-mail',
                first_name_path: 'user.userInfo.First_Name',
                last_name_path: 'user.userInfo.Last_Name',
                phone_number_path: 'user.userInfo.Phone_Number',
                user_role_path: 'user.userInfo.usertype',
                user_type_path: 'user.userInfo.usertype',
                user_id_path: 'user.userInfo.uid',
                user_location_path: "user.userInfo.country",
                user_locale_path:"user.userInfo.locale"

            },
            envEndpoint: {
                api: {
                    backend: '/backendavayacc_gss',
                    firestore: '/firestoreData',
                    saveTranscript: '/eptcct-axp-getEngagement/api/saveTranscript',
                    engagementLanguage: '/eptcct-axp-getEngagement/api/getEngagement'
                },
                static: {
                    media: 'static/media',
                }
            }
        }
    ]
}
